<template>
  <div>
    <AppHeader />

    <UMain class="!pt-0">
      <slot />
    </UMain>

    <AppFooter />
  </div>
</template>
